<template>
  <div>
    <div class='container'>
      <div class='order-list b_fff'>
        <div class='item-title flex'>
          <span class='t_999'>订单编号：{{dataInfo.PlatformOrderID}}</span>
        </div>
        <div class='item-list flex'>
          <div class='item-image'>
            <img :src='dataInfo.PicUrl' alt="" />
          </div>
          <div class='item-txt'>
            <div class='item-txt-top'>
              <div class='item-txt-top-1'>
                <plat-formLogo :shopType="dataInfo.ShopType"></plat-formLogo>
                <template>{{dataInfo.Title || '----'}}</template>
              </div>
            </div>
            <div class='item-txt-btm'>
              <span class='t_f23030'>￥{{dataInfo.DiscountPrice | toFixed}}</span>
              <span class="t_999"><del>￥{{dataInfo.ProductPrice | toFixed}}</del></span>
            </div>
          </div>
        </div>
      </div>
      <div class="order_from">
        <div class='b_black err-b fs-26'>
          <span>如已收到货，根据下方提示上传图片</span>
          <span class='iconfont icon-sanjiaoxing'></span>
        </div>
        <div class="order-form-tip">
          <p>上传商品与大拇指合照</p>
          <p class="t_999 tip-desc">点击右下方图片，可查看示例图</p>
          <i class="doc-icon"></i>
        </div>
        <!-- upload -->
        <div class="weui-cells sub-upload">
          <div class="weui-cell">
            <div class="weui-uploader">
              <div class="weui-uploader__bd">
                <div class="weui-uploader__files">
                  <div class="weui-uploader__input-box">
                    <div class="weui-uploader__input">
                      <input type="file" class="upload-input"
                        accept="image/*"
                        @change="selectImgChange($event)" />
                    </div>
                  </div>
                  <div
                    v-if="isUploading || isUploadFail || uploadImgSrc"
                    class="weui-uploader__file"
                    :class="[isUploading || isUploadFail ? 'weui-uploader__file_status' : '']"
                    @click="previewImage('upload')">
                    <img class="weui-uploader__img" v-if="uploadImgSrc" :src="uploadImgSrc" />
                    <div class="weui-uploader__file-content" v-if="isUploading">{{uploadingProgress}}%</div>
                    <div class="weui-uploader__file-content" v-if="isUploadFail">
                      <i>上传失败</i>
                    </div>
                  </div>
                  <!-- 示例图 -->
                  <div class="weui-uploader__file weui-uploader__file_status" @click="previewImage('exam')">
                    <img class="weui-uploader__img" :src="showRootPath + samplePic"/>
                    <div class="weui-uploader__file-content">示例</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class='order-btn b_fff flex'>
          <div>
            <mt-button type="default" @click="goBack">返回</mt-button>
          </div>
          <div class="btn-margin">
            <mt-button type="danger" @click="feedbackSubmit" :disabled="btnLoading">提交反馈</mt-button>
          </div>
        </div>
      </div>
    </div>
    <preview-dialog
      v-if="previewDialogShow"
      @close="previewDialogShow = false"
      :img-src="previewImgSrc">
    </preview-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { IMG_BASE_URL } from '@/config'
import { Toast, Indicator } from 'mint-ui'
import PreviewDialog from '@/components/puppetComponent/PreviewDialog'
import { UpaiyunUploadInfoGet } from '@/api/order'
import { LogisticsOrderInfoGet, LogisticsAuditAdd } from '@/api/feedback'

export default {
  data () {
    return {
      dataInfo: {},
      platformType: 0, // 2：拼多多
      isUploading: false,
      isUploadFail: false,
      uploadingProgress: 0,
      uploadImgSrc: '',
      uploadUserInfo: {},
      taskID: null,
      showRootPath: IMG_BASE_URL,
      samplePic: '/upaiyun/Sys/20191120/5625897106729800096.jpg',
      previewImgSrc: '',
      previewDialogShow: false,
      btnLoading: false
    }
  },
  components: {
    PreviewDialog
  },
  created () {
    this.taskID = this.$route.query.taskID ? this.$route.query.taskID : null
  },
  mounted () {
    if (this.taskID) {
      this.fetchData()
      this.fetchUploadInfo()
    } else {
      Toast('无任务ID')
      this.$router.go(-1)
    }
  },
  methods: {
    fetchData () {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      LogisticsOrderInfoGet({ taskId: this.taskID }).then(res => {
        Indicator.close()
        this.dataInfo = res.Data
        this.taskID = res.Data.TaskID
        this.platformType = this.$utils.shopTypeNumChangeToPlatformType(this.dataInfo.ShopType)
        this.dataInfo.ShopType = this.$utils.shopTypeNumChangeToText(this.dataInfo.ShopType)
      }).catch(() => {
        Indicator.close()
      })
    },
    // 获取上传图片信息
    fetchUploadInfo () {
      UpaiyunUploadInfoGet().then(res => {
        this.uploadUserInfo.uploadUrl = res.UploadUrl
        this.uploadUserInfo.loginName = res.LoginName
        this.uploadUserInfo.password = res.Screct
      })
    },
    // 图片上传
    selectImgChange (event) {
      let _this = this
      let rootPath = this.showRootPath
      let file = event.target.files[0]
      if (file) {
        let data = new FormData()
        data.append('logisticsFeedbackUpload', file)
        document.querySelector('.upload-input').value = ''
        axios({
          method: 'post',
          url: this.uploadUserInfo.uploadUrl,
          params: {
            loginName: this.uploadUserInfo.loginName,
            secret: this.uploadUserInfo.password
          },
          data: data,
          timeout: 60000,
          onUploadProgress: function (progressEvent) {
            // 显示相应的上传进度
            let percent = progressEvent.loaded / progressEvent.total * 100
            _this.uploadingProgress = parseInt(percent)
            _this.isUploading = true
            _this.isUploadFail = false
          }
        }).then(res => {
          if (res.status === 200 && res.data.StatusCode === 200) {
            // 上传成功，展示图片，隐藏进度条
            this.uploadImgSrc = rootPath + res.data.Message
            this.isUploading = false
            this.isUploadFail = false
          } else {
            Toast(res.Message)
            this.uploadingProgress = 0
            this.uploadImgSrc = ''
            this.isUploading = false
            this.isUploadFail = true
          }
        }).catch(() => {
          Toast('上传图片失败！请重新上传')
          this.uploadingProgress = 0
          this.uploadImgSrc = ''
          this.isUploading = false
          this.isUploadFail = true
        })
      }
    },
    previewImage (type) {
      if (type === 'upload') {
        this.previewImgSrc = this.uploadImgSrc
      } else if (type === 'exam') {
        this.previewImgSrc = this.showRootPath + this.samplePic
      }
      this.previewDialogShow = true
    },
    goBack () {
      this.$router.go(-1)
    },
    // 反馈
    feedbackSubmit () {
      if (!this.taskID) {
        Toast('无任务ID')
        return
      }
      if (!this.uploadImgSrc) {
        Toast('请上传图片')
        return
      }
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      this.btnLoading = true
      LogisticsAuditAdd({
        taskId: this.taskID,
        picUrl: this.uploadImgSrc
      }).then(res => {
        Indicator.close()
        this.btnLoading = false
        Toast('反馈成功')
        setTimeout(() => {
          this.$router.go(-1)
        }, 1500)
      }).catch(err => {
        Indicator.close()
        this.btnLoading = false
        Toast(err.ErrMsg)
      })
    }
  },
  filters: {
    toFixed (value) {
      if (!value) {
        value = 0
      }
      return parseFloat(value).toFixed(2)
    }
  }
}
</script>

<style scoped>
  .flex{
    display: flex;
  }
  .space-between{
    justify-content:space-between;
  }
  .b_black{
    background: #2c2c2c;
    color: #fff;
  }
  .item-title{
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    box-sizing: border-box;
    padding:3% 4%;
    font-size: 14px;
    border-bottom: 1px solid #eee;
  }
  .item-image{
    width: 7em;
    height: 7em;
    margin-right: 0.7em;
    flex-shrink: 0;
  }
  .item-image img{
    width: 100%;
    height: 100%;
    border-radius: 6px;
  }
  .item-list{
    padding:2% 1%;
  }
  .err-b{
    position: relative;
    z-index: 99;
    width:100%;
    line-height: 24px;
    margin-top: 3%;
    box-sizing: border-box;
    padding:8px 10px;
  }
  .err-b .iconfont{
    position: absolute;
    font-size:1.5em;
    left: 1em;
    color: #2c2c2c;
    bottom: -16px;
  }
  .item-txt{
    position: relative;
    height: 7em;
    flex-grow: 1;
  }
  .item-txt-top-1{
    height: 2.8em;
    line-height: 1.5em;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp:2;
    -webkit-box-orient:vertical;
  }
  .item-txt-btm{
    position: absolute;
    bottom:0;
    min-width: 90%;
  }
  .item-txt-btm span:last-child{
    margin-left: 5px;
  }
  .icon-sanjiaoxing-copy{
    top: -1.1em;
    color:#f05c61;
  }
  .sub-upload{
    margin:-2px 0 5.3em 0;
    background: #fff;
    border-bottom: 1px solid #eee;
  }
  .order-btn{
    justify-content:flex-end;
    position: fixed;
    align-items: center;
    bottom: 0;
    height: 65px;
    line-height: 65px;
    width: 100%;
    box-sizing: border-box;
    overflow: hidden;
    z-index:100;
  }
  .order-btn button{
    font-size: 14px;
    padding: 0px 15px;
    height: 2.5em;
    line-height: 2.5em;
    margin: 0;
  }
  .order-btn .btn-margin {
    margin: 0 15px;
  }
  .order_from{
    display: block;
    padding-bottom: 5em;
  }
  .order-form-tip{
    position: relative;
    padding: 15px 30px 5px 30px;
    font-size: 14px;
    background: #fff;
    line-height: 20px;
  }
  .order-form-tip .tip-desc{
    margin-top: 5px;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
  }
  .order-form-tip .doc-icon{
    position: absolute;
    top: 22px;
    left: 16px;
    display: block;
    width: 8px;
    height: 8px;
    background: #f05c61;
    border-radius: 50%;
  }
  /**
    upload
   */
  .upload-input{
    height: 100%;
    width: 100%;
    display: block;
  }
  .weui-cell {
    padding:10px 15px;
    position:relative;
    display:flex;
    align-items:center;
    min-height:2.5em;
  }
  .weui-uploader__bd {
    margin-bottom:-4px;
    margin-right:-9px;
    overflow:hidden;
  }
  .weui-uploader__input-box {
    float:left;
    position:relative;
    margin-right:9px;
    margin-bottom:9px;
    width:77px;
    height:77px;
    border:1px solid #d9d9d9;
  }
  .weui-uploader__input-box:before {
    width: 2px;
    height: 39.5px;
  }
  .weui-uploader__input-box:before, .weui-uploader__input-box:after {
    content: " ";
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    background-color: #D9D9D9;
  }
  .weui-uploader__input-box:after {
    width: 39.5px;
    height: 2px;
  }
  .weui-uploader__input-box:before, .weui-uploader__input-box:after {
    content: " ";
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    background-color: #D9D9D9;
  }
  .weui-uploader__input {
    position:absolute;
    z-index:1;
    top:0;
    left:0;
    width:100%;
    height:100%;
    opacity:0;
  }
  .weui-uploader__file {
    float:left;
    margin-right:9px;
    margin-bottom:9px;
  }
  .weui-uploader__file_status {
    position:relative;
  }
  .weui-uploader__file-content {
    position:absolute;
    top:50%;
    left:50%;
    transform:translate(-50%, -50%);
    color:#fff;
  }
  .weui-uploader__img {
    display:block;
    width:79px;
    height:79px;
    overflow: hidden;
  }
  .weui-uploader__file {
    float: left;
    margin-right: 9px;
    margin-bottom: 9px;
    width: 79px;
    height: 79px;
    background: no-repeat center center;
    background-size: cover;
  }
  .weui-uploader__file_status {
    position: relative;
  }
  .weui-uploader__file_status:before {
    content: " ";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .weui-uploader__file-content {
    display: none;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    color: #FFFFFF;
  }
  .weui-uploader__file_status .weui-uploader__file-content {
    display: block;
  }
</style>
